__webpack_require__.p = "/acquisition-adjust-segment-events/onboarding/";